import ApplicationLayout from 'components/ApplicationLayout';
import { SIDEBAR_PORTAL_ID } from 'features/domain-simulation/SimulationDetailSidebar';
import MainNavigation from 'components/navigation/MainNavigation';
import './_style.scss';
import { IntlProvider } from 'react-intl';
import { NavLink, Outlet } from 'react-router-dom';
import { ROUTES } from 'routes/types';
import { DEFAULT_LOCALE } from 'store/i18n/lang';
import { getDisplayMessages, getLocale } from 'store/i18n/langSlice';
import { useAppSelector } from 'store/setup/hooks';

const simulationsNavItems = [
    {
        key: 'simulations',
        route: (
            <NavLink to={`/${ROUTES.SIMULATIONS}/v1`}>
                <p className='font-display text-14 font-semibold text-uppercase'>Simulations</p>
            </NavLink>
        ),
    },
    {
        key: 'simulations-v2',
        route: (
            <NavLink to={`/${ROUTES.SIMULATIONS}/v2`}>
                <p className='font-display text-14 font-semibold text-uppercase'>Simulation 2.0</p>
            </NavLink>
        ),
    },
    {
        key: 'simulations-domain',
        route: (
            <NavLink to={`/${ROUTES.SIMULATIONS}/domain`}>
                <p className='font-display text-14 font-semibold text-uppercase'>Domain Simulation</p>
            </NavLink>
        ),
    },
    {
        key: 'route-builder',
        route: (
            <NavLink to={`/${ROUTES.SIMULATIONS}/route-builder`}>
                <p className='font-display text-14 font-semibold text-uppercase'>Route Builder</p>
            </NavLink>
        ),
    },
];

const SimulationsLayout = () => {
    const userLocale = useAppSelector(getLocale);
    const displayMessages = useAppSelector(getDisplayMessages);

    if (!displayMessages || !userLocale) {
        return null;
    }

    return (
        <IntlProvider defaultLocale={DEFAULT_LOCALE} key={userLocale} locale={userLocale} messages={displayMessages}>
            <ApplicationLayout>
                <ApplicationLayout.Header>
                    <MainNavigation showHomeIcon={false} navItems={simulationsNavItems} />
                </ApplicationLayout.Header>
                <ApplicationLayout.Sidebar className='right'>
                    <div id={SIDEBAR_PORTAL_ID} className='SimulationsLayout__sidebarTarget' />
                </ApplicationLayout.Sidebar>
                <ApplicationLayout.Body innerClassName='p-0 padding-0'>
                    <Outlet />
                </ApplicationLayout.Body>
            </ApplicationLayout>
        </IntlProvider>
    );
};

export default SimulationsLayout;
